import React from 'react';
import { Avatar } from '@mui/material';
import { clientAvatarColor, clientInitials } from '../../Utils/format';

const ClientAvatar = ({ name, size = 36, sx = {} }) => {
  const fontSize = size === 44 ? 18 : size === 36 ? 14 : Math.round(size * 0.4);
  return (
    <Avatar
      sx={{
        bgcolor: clientAvatarColor(name),
        width: size,
        height: size,
        fontSize,
        fontWeight: 700,
        ...sx,
      }}
    >
      {clientInitials(name)}
    </Avatar>
  );
};

export default ClientAvatar;
